import { isEqualValueDefault } from "@ixfx/core";
import { cache } from "../cache.js";
import { initUpstream } from "../init-stream.js";
import { combineLatestToObject } from "../ops/combine-latest-to-object.js";
export function derived(fn, reactiveSources, options = {}) {
    const ignoreIdentical = options.ignoreIdentical ?? true;
    const eq = options.eq ?? (isEqualValueDefault);
    const sources = combineLatestToObject(reactiveSources);
    const handle = (v) => {
        const last = output.last();
        const vv = fn(v);
        if (vv !== undefined) {
            if (ignoreIdentical && last !== undefined) {
                if (eq(vv, last))
                    return vv;
            }
            output.set(vv);
        }
        return vv;
    };
    // When the combined stream emits a value, output it
    const s = initUpstream(sources, {
        ...options,
        onValue(v) {
            handle(v);
        },
    });
    const output = cache(s, fn(sources.last()));
    return output;
}
